export default theme => ({
    passEditor: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
        display: 'flex',
        flexDirection: 'column',
        padding: `0px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        '& .submitButton': {
            marginTop: 30,
        },
    },
});
